import { Colors } from "../constants/colors";

export const FONTS = {
  BOLD: "ey_interstate",
  REGULAR: "ey_interstate",
  LIGHT: "ey_interstate",
};

export const FONT_FAMILIES = {
  BOLD: {
    fontFamily: FONTS.BOLD,
    fontWeight: "bold",
  },
  REGULAR: {
    fontFamily: FONTS.REGULAR,
    fontWeight: 400,
  },
  LIGHT: {
    fontFamily: FONTS.LIGHT,
    fontWeight: "lighter",
  },
};

export const defaultFontSize = 14;

export const getEmFontSize = (size) => `${size}px`;

export const heroStyles = {
  heroTitle: {
    ...FONT_FAMILIES.BOLD,
    fontSize: getEmFontSize(26),
    color: Colors.GREY200,
    lineHeight: getEmFontSize(35),
  },
  heroDescription: {
    ...FONT_FAMILIES.LIGHT,
    fontSize: getEmFontSize(16),
    color: Colors.GREY50,
    lineHeight: getEmFontSize(19),
  },
};

export const academyStyles = {
  academyCardTitle: {
    ...FONT_FAMILIES.REGULAR,
    fontSize: getEmFontSize(16),
    color: Colors.GREY50,
    lineHeight: getEmFontSize(20),
  },
};

export const htmlStyles = {
  body2: {
    ...FONT_FAMILIES.LIGHT,
    fontSize: getEmFontSize(14),
    color: Colors.GREY50,
    lineHeight: getEmFontSize(19),
  },
  body2bold: {
    ...FONT_FAMILIES.REGULAR,
    fontSize: getEmFontSize(14),
    color: Colors.GREY50,
    lineHeight: getEmFontSize(19),
  },
  body1: {
    ...FONT_FAMILIES.LIGHT,
    fontSize: getEmFontSize(12),
    color: Colors.GREY50,
    lineHeight: getEmFontSize(16),
  },
  body1bold: {
    ...FONT_FAMILIES.REGULAR,
    fontSize: getEmFontSize(12),
    color: Colors.GREY50,
    lineHeight: getEmFontSize(16),
  },
  cardSectionHeading: {
    // Card & section heading
    ...FONT_FAMILIES.REGULAR,
    fontSize: getEmFontSize(14),
    color: Colors.WHITE,
    lineHeight: getEmFontSize(18),
    letterSpacing: 1.5,
    textTransform: "uppercase",
  },
};

export const courseStyles = {
  courseCarouselTitle: {
    ...FONT_FAMILIES.BOLD,
    fontSize: getEmFontSize(16),
    color: Colors.WHITE,
    lineHeight: getEmFontSize(18),
  },
  courseCardTitle: {
    ...FONT_FAMILIES.LIGHT,
    fontSize: getEmFontSize(14),
    color: Colors.WHITE,
    lineHeight: getEmFontSize(18),
  },
  courseCardDuration: {
    ...FONT_FAMILIES.BOLD,
    fontSize: getEmFontSize(12),
    color: Colors.GREY50,
    lineHeight: getEmFontSize(18),
  },
  courseCardHoverTitle: {
    ...FONT_FAMILIES.REGULAR,
    fontSize: getEmFontSize(14),
    color: Colors.WHITE,
    lineHeight: getEmFontSize(18),
  },
  progressBarLabel: {
    ...FONT_FAMILIES.LIGHT,
    fontSize: getEmFontSize(12),
    color: Colors.GREY100,
    lineHeight: getEmFontSize(24),
    letterSpacing: 0,
  },
};

export const detailsStyles = {
  detailsPageHeading: {
    ...FONT_FAMILIES.BOLD,
    fontSize: getEmFontSize(26),
    color: Colors.GREY200,
    lineHeight: getEmFontSize(35),
  },
  detailsTotal: {
    ...FONT_FAMILIES.BOLD,
    fontSize: getEmFontSize(24),
    color: Colors.GREY50,
    lineHeight: getEmFontSize(18),
  },
  detailsTotalDescription: {
    ...FONT_FAMILIES.LIGHT,
    fontSize: getEmFontSize(14),
    color: Colors.GREY50,
    lineHeight: getEmFontSize(18),
  },
};

export const textStyles = {
  textLabel: {
    ...FONT_FAMILIES.REGULAR,
    fontSize: getEmFontSize(10),
    color: Colors.GREY300,
    lineHeight: getEmFontSize(16),
    letterSpacing: 0,
  },
  textValue: {
    ...FONT_FAMILIES.REGULAR,
    fontSize: getEmFontSize(12),
    color: Colors.GREY50,
    lineHeight: getEmFontSize(16),
    letterSpacing: 0.4,
  },
  textDisabled: {
    color: "#A8A8AC",
  },
  textLink: {
    color: Colors.BLUE500,
  },
};
